// extracted by mini-css-extract-plugin
module.exports = {"activityListTitle":"FKxze","activitiesList":"T2ea-","activitiesListInner":"CMV6l","loadingWrapper":"jVBxS"};